import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@1trading/react/components/ui/select';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ACTIVITY_BANDS, TRADING_VOLUME_BANDS } from '@/constants/institution';
import type { InstitutionExpectedActivityOrDefaults } from '@/features/institution/expected-activity/schema';

const InstitutionExpectedActivityFieldsetMonthlyActivity = () => {
  const form = useFormContext<InstitutionExpectedActivityOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        name="monthlyFiatDeposits"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.monthlyFiatDeposits')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.expectedActivity.placeholders.monthlyFiatDeposits')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {ACTIVITY_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.expectedActivity.activityBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="monthlyFiatWithdrawals"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.monthlyFiatWithdrawals')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.expectedActivity.placeholders.monthlyFiatWithdrawals')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {ACTIVITY_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.expectedActivity.activityBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="monthlyCryptoDeposits"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.monthlyCryptoDeposits')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.expectedActivity.placeholders.monthlyCryptoDeposits')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {ACTIVITY_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.expectedActivity.activityBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="monthlyCryptoWithdrawals"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.monthlyCryptoWithdrawals')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.expectedActivity.placeholders.monthlyCryptoWithdrawals')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {ACTIVITY_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.expectedActivity.activityBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="monthlyTradingVolume"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.monthlyTradingVolume')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.expectedActivity.placeholders.monthlyTradingVolume')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {TRADING_VOLUME_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.expectedActivity.tradingVolumeBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionExpectedActivityFieldsetMonthlyActivity.displayName = 'InstitutionExpectedActivityFieldsetMonthlyActivity';

export { InstitutionExpectedActivityFieldsetMonthlyActivity };
